export default {
  // Endpoints
  loginEndpoint: '/api/v1/auth/login',
  registerEndpoint: '/api/v1/auth/register',
  meEndpoint: '/api/v1/auth/me',
  updatePassword: '/api/v1/users/change_password',
  providers: '/api/v1/providers',
  regions: '/api/v1/regions',
  pricing: '/api/v1/pricing',
  apiKeyEndpoint: '/api/v1/api_keys',
  exportsEndpoint: '/api/v1/exports',
  adminExportsConsignment: '/api/v1/admin/exports/consignment',
  adminExportsConsignmentReport:
    '/api/v1/admin/exports/consignment-operation-report-by-operation-date',
  customerExportsConsignment: '/api/v1/customer/exports/consignment',
  consignments: '/api/v1/consignments',
  warehouses: '/api/v1/warehouses',
  customers: '/api/v1/customers',
  users: '/api/v1/users',
  customersParameters: '/api/v1/customer-parameters',
  customersDocuments: '/api/v1/customer-documents',
  consignmentDocument: '/api/v1/consignment-documents',
  products: '/api/v1/products',
  packages: '/api/v1/packages',
  billCalculations: '/api/v1/bill-calculation',
  forgotPasswordEndpoint: '/api/v1/users/forgot-password',
  resetPasswordEndpoint: '/api/v1/users/reset-password',
  refreshEndpoint: '/service/refresh-token',
  constantEndpoint: '/api/v1/constant',
  roles: '/api/v1/roles',
  permissions: '/api/v1/permissions',
  offers: '/api/v1/offers',
  customer: '/api/v1/customer',
  dashboard: '/api/v1/dashboard',
  departments: '/api/v1/departments',
  postalCode: '/api/v1/postal_codes',
  translations: '/api/v1/translations',
  webhooks: '/api/v1/webhooks',
  notification: '/api/v1/notifications',
  taxes: '/api/v1/taxes',
  taxOffices: '/api/v1/tax-offices',
  pickups: '/api/v1/pickups',
  providerPrices: '/api/v1/provider-prices',
  providerSpecialServices: '/api/v1/provider-special-services',
  customerRegionPrices: '/api/v1/customer-region-prices',
  customerRegionPricesTable: '/api/v1/customer-region-prices-table',
  providerPriceTable: '/api/v1/provider-price-table',
  reportService: '/api/v1/reports',
  reconciliationService: '/api/v1/reconciliation',
  payment: '/api/v1/payment-intents',
  adminBarcodePool: '/api/v1/admin/barcode-pool',
  adminBarcodePoolGenerate: '/api/v1/admin/barcode-pool/generate',
  adminBarcodePoolPurge: '/api/v1/admin/barcode-pool/purge',
  adminBarcodeRanges: '/api/v1/admin/barcode-ranges',
  customerBarcodePoolGenerate: '/api/v1/customer/barcode-pool/generate',
  customerBarcodeRanges: '/api/v1/customer/barcode-ranges',

  // e.g. Authorization: Bearer <token>
  tokenType: 'Bearer',

  // Value of this property will be used as key to store JWT token in storage
  storageTokenKeyName: 'accessToken',
  storageRefreshTokenKeyName: 'refreshToken'
};
